import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-showcase',
  templateUrl: './modal-showcase.component.html',
  styleUrls: ['./modal-showcase.component.scss']
})
export class ModalShowcaseComponent {
  basicModalOpen = false;
  smallModalOpen = false;
  mediumModalOpen = false;
  largeModalOpen = false;
  noBackdropClickModalOpen = false;
  noCloseButtonModalOpen = false;
  confirmModalOpen = false;
  rightSmallModalOpen = false;
  rightMediumModalOpen = false;
  rightLargeModalOpen = false;
  noFooterModalOpen = false;
  noFooterRightModalOpen = false;
  okCancelModalOpen = false;
  successModalOpen = false;
  infoModalOpen = false;
  warningModalOpen = false;
  errorModalOpen = false;
  yesNoModalOpen = false;

  openBasicModal(): void {
    this.basicModalOpen = true;
  }

  closeBasicModal(): void {
    this.basicModalOpen = false;
  }

  openSmallModal(): void {
    this.smallModalOpen = true;
  }

  closeSmallModal(): void {
    this.smallModalOpen = false;
  }

  openMediumModal(): void {
    this.mediumModalOpen = true;
  }

  closeMediumModal(): void {
    this.mediumModalOpen = false;
  }

  openLargeModal(): void {
    this.largeModalOpen = true;
  }

  closeLargeModal(): void {
    this.largeModalOpen = false;
  }

  openNoBackdropClickModal(): void {
    this.noBackdropClickModalOpen = true;
  }

  closeNoBackdropClickModal(): void {
    this.noBackdropClickModalOpen = false;
  }

  openNoCloseButtonModal(): void {
    this.noCloseButtonModalOpen = true;
  }

  closeNoCloseButtonModal(): void {
    this.noCloseButtonModalOpen = false;
  }

  openConfirmModal(): void {
    this.confirmModalOpen = true;
  }

  closeConfirmModal(): void {
    this.confirmModalOpen = false;
  }

  onConfirm(): void {
    alert('Confirmed!');
    this.confirmModalOpen = false;
  }

  openRightSmallModal(): void {
    this.rightSmallModalOpen = true;
  }

  openRightMediumModal(): void {
    this.rightMediumModalOpen = true;
  }

  openRightLargeModal(): void {
    this.rightLargeModalOpen = true;
  }

  openOkCancelModal(): void {
    this.okCancelModalOpen = true;
  }

  onOk(): void {
    alert('OK clicked');
    this.okCancelModalOpen = false;
  }

  onCancel(): void {
    this.okCancelModalOpen = false;
  }

  onYes(): void {
    alert('Yes clicked');
    this.yesNoModalOpen = false;
  }

  onNo(): void {
    this.yesNoModalOpen = false;
  }
}
